import React from "react";
import {makeStyles, Typography} from "@material-ui/core";
import {blue} from "@material-ui/core/colors";

/** "—— Section 2 ——": the separator's source title between two divider lines. */
const useStyles = makeStyles(({spacing}) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: spacing(1.25),
    minWidth: 0,
  },
  line: {
    flexShrink: 0,
    width: spacing(3),
    height: 1,
    backgroundColor: blue.A400,
  },
  title: {
    color: blue.A400,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));

const LocalisationSeparatorTitle = ({title}: {title: string}) => {
  const classes = useStyles();

  return (
    <span className={classes.root}>
      <span className={classes.line} />
      <Typography variant="body2" className={classes.title} component="span">
        {title}
      </Typography>
      <span className={classes.line} />
    </span>
  );
};

export default LocalisationSeparatorTitle;
